var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrigin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 101,
    viewBox: "0 0 91 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0389 0.00292969H0.00769043V100.41H90.0389V0.00292969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1849 80.1725L18.7436 40.808C16.0807 36.6728 14.6788 31.9815 14.6788 27.2068C14.6788 12.1924 28.275 0.0032959 45.0232 0.0032959C61.7703 0.0032959 75.3675 12.1924 75.3675 27.2068C75.3675 31.9815 73.9656 36.6728 71.3017 40.808L48.8273 80.1725C48.1087 81.4325 46.6273 82.2306 45.0061 82.2306C43.3848 82.2306 41.9034 81.4325 41.1849 80.1725ZM45.0151 12.1244C37.9332 12.1244 32.1828 17.8747 32.1828 24.9575C32.1828 32.0394 37.9332 37.7898 45.0151 37.7898C52.098 37.7898 57.8475 32.0394 57.8475 24.9575C57.8475 17.8747 52.098 12.1244 45.0151 12.1244Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6806 88.2092H87.6332C88.9609 88.2092 90.0384 89.4396 90.0384 90.9546V97.6675C90.0384 99.1825 88.9609 100.411 87.6332 100.411H2.39707C1.06932 100.411 -0.00817871 99.1825 -0.00817871 97.6675V90.9546C-0.00817871 89.4396 1.06932 88.2092 2.39707 88.2092H36.3505C37.5892 92.3106 41.0026 95.2611 45.0156 95.2611C49.0276 95.2611 52.4411 92.3106 53.6806 88.2092Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrigin);
export default __webpack_public_path__ + "static/media/icon_origin.2c8a9776144f3fdf5ea4b5fe7e43a383.svg";
export { ForwardRef as ReactComponent };